// Role categories and their associated professional titles
export const ROLE_CATEGORIES = [
  {
    id: 'design',
    name: 'Diseño',
    roles: ['UI/UX Designer', 'Graphic Designer', 'Product Designer', 'Visual Designer']
  },
  {
    id: 'dev',
    name: 'Desarrollo',
    roles: ['Frontend Developer', 'Backend Developer', 'Full Stack Developer', 'DevOps Engineer']
  },
  {
    id: 'marketing',
    name: 'Marketing',
    roles: ['Marketing Manager', 'Social Media Specialist', 'Content Strategist', 'SEO Specialist']
  },
  {
    id: 'business',
    name: 'Negocios',
    roles: ['Business Analyst', 'Project Manager', 'Sales Director', 'Product Manager']
  }
];

// Filter categories including "All"
export const FILTER_CATEGORIES = [
  { id: 'all', name: 'Todos' },
  ...ROLE_CATEGORIES
];

// Company names for profiles
export const COMPANIES = [
  'TechCorp',
  'InnovateLab',
  'DesignHub',
  'MarketPro',
  'DevStudio',
  'CreativeMinds',
  'DataFlow',
  'CloudNine',
  'PixelPerfect',
  'CodeCraft'
];

// API configuration
export const API_CONFIG = {
  BASE_URL: 'https://randomuser.me/api/',
  RESULTS_COUNT: 14,
  NATIONALITIES: 'us,gb,es,fr,de'
};
